import { render, staticRenderFns } from "./categoriesManager.vue?vue&type=template&id=47e1cbec&scoped=true&"
import script from "./categoriesManager.vue?vue&type=script&lang=js&"
export * from "./categoriesManager.vue?vue&type=script&lang=js&"
import style0 from "./categoriesManager.vue?vue&type=style&index=0&id=47e1cbec&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47e1cbec",
  null
  
)

export default component.exports